import { Injectable } from '@angular/core';

/**
 * Formats badge-related notification messages ({badgeName}, {tierName}, {problemName}...).
 * Shared by the notification list page and the topbar dropdown so the placeholder handling
 * lives in a single place for the new badge event types.
 */
@Injectable({ providedIn: 'root' })
export class BadgeNotificationFormatterService {
  private readonly badgeEventTypes = [
    'BadgeAwarded',
    'BadgeTierUpgraded',
    'AlgorithmMasterNewProblem',
    'BadgeRevoked',
  ];

  isBadgeEvent(eventType: string): boolean {
    return this.badgeEventTypes.indexOf(eventType) !== -1;
  }

  /**
   * Replaces every {key} placeholder with its parameter value (url excluded). Values are
   * HTML-escaped since the message is rendered as HTML and some (a revoke reason) are free text.
   */
  applyParameters(message: string, parameters: { key: string; value: string }[]): string {
    let result = message;
    (parameters || []).forEach(parameter => {
      if (parameter.key.toLowerCase() === 'url') {
        return;
      }
      result = result.replace('{' + parameter.key + '}', this.escapeHtml(parameter.value));
    });
    return result;
  }

  private escapeHtml(value: string): string {
    return (value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
}
